import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import { FormattedMessage as T } from "react-intl";
import AgreementForm from "./AgreementForm";
import { Mode } from "types/common-types";

const AgreementEdit = () => {
  const { agreementsUrl } = useGlobalContext();

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={agreementsUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h5" mb={3}>
        <T id="editAgreement" />
      </Typography>
      <AgreementForm mode={Mode.Update} />
    </>
  );
};

export default AgreementEdit;
